module.exports = __webpack_public_path__ + "img/east-harlem.748a5084.jpg";